export default function Arrow({ angle }) {
    return (
        <svg id="Action" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" style={{ rotate: angle }}>
            <g id="Action-2" data-name="Action" fill="#1577ea" stroke="#3875e2" stroke-width="1">
                <rect width="50" height="50" rx="25" stroke="none"/>
                <rect x="0.5" y="0.5" width="49" height="49" rx="24.5" fill="none"/>
            </g>
            <g id="Group_1468" data-name="Group 1468" transform="translate(10 10)">
                <path id="Path_56" data-name="Path 56" d="M0,0H30V30H0Z" fill="none"/>
                <path id="Path_57" data-name="Path 57" d="M14.211,17.959l6.1-6.151,1.609,1.622-8.851,8.92-8.851-8.92,1.609-1.622,6.1,6.151V4h2.276Z" transform="translate(1.927 1.826)" fill="#fcfcfc"/>
            </g>
        </svg>
    )
}